import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M12.5 12.5h6.25v1.25H12.5V12.5zm0 2.5h6.25v1.25H12.5V15zm0 2.5h6.25v1.25H12.5V17.5zm-2.5-5A2.445 2.445 0 017.5 10 2.445 2.445 0 0110 7.5a2.445 2.445 0 012.5 2.5h1.25A3.75 3.75 0 1010 13.75V12.5z"
      ></path>
      <path
        fill="currentColor"
        d="M18.316 6.902l-1.475-2.554a1.249 1.249 0 00-1.484-.56l-1.521.515a6.91 6.91 0 00-.82-.474l-.315-1.575a1.25 1.25 0 00-1.226-1.004h-2.95A1.25 1.25 0 007.3 2.255l-.315 1.574a6.855 6.855 0 00-.83.471l-1.512-.512a1.249 1.249 0 00-1.483.56L1.685 6.902a1.25 1.25 0 00.257 1.564l1.207 1.06c-.01.158-.024.315-.024.474 0 .161.007.32.018.479l-1.2 1.055a1.25 1.25 0 00-.258 1.563l1.475 2.556a1.249 1.249 0 001.483.559l1.522-.515c.262.177.536.335.82.474l.314 1.574a1.25 1.25 0 001.226 1.005H10V17.5H8.525l-.443-2.219a5.683 5.683 0 01-1.685-.982l-2.154.729-1.475-2.556 1.703-1.496a5.579 5.579 0 01-.004-1.955l-1.7-1.494 1.476-2.554 2.142.724a5.644 5.644 0 011.697-.978L8.525 2.5h2.95l.444 2.219c.614.228 1.184.56 1.684.982l2.155-.728 1.475 2.554-1.749 1.533.824.94 1.75-1.534a1.25 1.25 0 00.258-1.563z"
      ></path>
    </svg>
  );
}

export default SvgComponent;
